"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logger = void 0;
/* eslint-disable no-console */

const info = function () {
  return console.info(...arguments);
};
const warn = function () {
  return console.warn(...arguments);
};
const error = function () {
  return console.error(...arguments);
};
const logger = exports.logger = {
  info,
  warn,
  error
};